import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';

const PartnersSection = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const res = await fetch('/api/partners.php'); // رابط API الخاص بك
        const text = await res.text(); // نقرأ النص أولاً
        const data = text ? JSON.parse(text) : []; // نتأكد أن النص مش فاضي قبل JSON.parse
        setPartners(data);
      } catch (err) {
        console.error('فشل تحميل الشركاء:', err);
        setPartners([]); // لو فيه خطأ نعرض مصفوفة فاضية
      }
    };

    fetchPartners();
  }, []);

  return (
    <section id="partners" className="py-24 bg-gradient-to-br from-gray-50 via-white to-green-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-green-300 rounded-full filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-300 rounded-full filter blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-20" dir="rtl">
          <div className="inline-flex items-center gap-2 mb-4 px-6 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-full shadow-lg">
            <Sparkles className="w-5 h-5" />
            <span className="font-semibold">شركاؤنا في النجاح</span>
          </div>
          <h2 className="text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            في الوسيط الناقل للنقل
          </h2>
          <p className="text-2xl text-gray-700 max-w-4xl mx-auto font-medium">
            نؤمن أنه <span className="text-green-600">لايمكن التقدم</span> إلا عندما <span className="text-green-600">نعمل معاً</span>
          </p>
          <div className="w-32 h-1 bg-gradient-to-r from-green-500 to-green-600 mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
          {partners.map((partner, index) => (
            <div
              key={partner.id}
              className="group relative bg-white rounded-2xl p-6 hover:shadow-2xl transition-all duration-500 flex flex-col items-center justify-center text-center border-2 border-gray-100 hover:border-green-400 transform hover:-translate-y-2 cursor-pointer"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-green-50 to-blue-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
              <div className="relative z-10">
                <div className="w-20 h-20 mb-4 flex items-center justify-center transform group-hover:scale-110 transition-transform duration-500">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-w-full max-h-full object-contain"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://via.placeholder.com/80x80?text=" + encodeURIComponent(partner.name);
                    }}
                  />

                </div>
                <h3 className="text-sm font-bold text-gray-800 mb-1 group-hover:text-green-700 transition-colors" dir="rtl">{partner.name}</h3>
                {partner.license && (
                  <p className="text-xs text-gray-500 group-hover:text-gray-700 transition-colors" dir="rtl">{partner.license}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
